import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_BASE_URL } from '../../../services/api';

export const validateZipcode = createAsyncThunk('zipcode/validate', async (zipcode, thunkAPI) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/zipcode`, { zipcode });
    return { valid: response.data.valid, zipcode };
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.msg || error.message);
  }
});

const initialState = { isValid: false, zipcode: '', isLoading: false, error: null };
const zipcodeSlice = createSlice({
  name: 'zipcode',
  initialState,
  reducers: { resetZipcode: (state) => { state.isValid = false; state.zipcode = ''; state.error = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(validateZipcode.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(validateZipcode.fulfilled, (state, action) => { state.isLoading = false; state.isValid = action.payload.valid; state.zipcode = action.payload.zipcode; })
      .addCase(validateZipcode.rejected, (state, action) => { state.isLoading = false; state.isValid = false; state.error = action.payload; });
  },
});
export const { resetZipcode } = zipcodeSlice.actions;
export default zipcodeSlice.reducer;